import usePDPBasicDetails from 'components/consumer/PDP/state/context/usePDPBasicDetails';

const useProductEFGInternalStatus = () => {
  const {
    loading: basicDetailsLoading,
    data: basicDetails,
  } = usePDPBasicDetails();

  return {
    loading: basicDetailsLoading,
    isEFGInternal: !!(basicDetails?.efg_flag && !basicDetails.is_external),
  };
};

export default useProductEFGInternalStatus;
